<template lang="pug">
.contact
  .contact__wrap
    .contact__header
      h1.contact__header-title Contact
      .contact__header-close
        router-link(
          to='/'
          @click.native="toHome()"
          )
          .contact__header-close-line1
          .contact__header-close-line2
    .contact__body
      form
        .contact__body-input(
          :class="{err: form.name.err}"
          )
          input(
            type='text'
            placeholder='name'
            v-model="form.name.value"
            )
        .contact__body-input(
          :class="{err: form.email.err}"
          )
          input(
            type='email'
            placeholder='e-mail'
            v-model="form.email.value"
            )
        .contact__body-textarea(
          :class="{err: form.message.err}"
          )
          textarea(
            v-model="form.message.value"
            )
        .contact__body-attention(
          :class="{on: sendContact}"
          )
          | Thank you for your inquiry!!
        .contact__body-submit
          button(
            type='button'
            name='button'
            @click="submit()"
            )
            span Submit
</template>

<script>
export default {
  name: "Contact",
  mounted: function() {
    this.$store.dispatch("changePage", {
      page: "contact",
    });
  },
  data: function() {
    return {
      sendContact: false,
      form: {
        name: {
          value: "",
          err: false,
        },
        email: {
          value: "",
          err: false,
        },
        message: {
          value: "",
          err: false,
        },
      },
    };
  },
  methods: {
    toHome: function() {
      this.$store.dispatch("changePage", {
        page: "home",
      });
    },
    submit: function() {
      // init
      this.form.name.err = false;
      this.form.email.err = false;
      this.form.message.err = false;

      let isErr = false;
      if (this.form.name.value === "") {
        isErr = true;
        this.form.name.err = true;
      }

      if (this.form.email.value == "") {
        isErr = true;
        this.form.email.err = true;
      }

      if (this.form.message.value == "") {
        isErr = true;
        this.form.message.err = true;
      }

      if (isErr) return;

      // send mail
      var req = new XMLHttpRequest();
      req.onreadystatechange = () => {
        if (req.readyState == 4) {
          if (req.status == 200) {
            // 通信の成功時
            console.log("send success");
            this.sendContact = true;
          }
        } else {
        }
      };
      req.open("POST", "../send-mail.php", true);
      req.setRequestHeader(
        "content-type",
        "application/x-www-form-urlencoded;charset=UTF-8"
      );
      const n = this.form.name.value;
      const e = this.form.email.value;
      const m = this.form.message.value;
      req.send(`name=${n}&email=${e}&text=${m}`);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/foundation/_mixin";

.contact {
  position: absolute;
  left: 30px;
  top: 30px;
  padding-bottom: 30px;
  width: calc(100% - 60px);
  min-height: calc(100vh - 60px);
  z-index: 100;
  @include l-mobile {
    left: 15px;
    top: 15px;
    width: calc(100% - 30px);
  }
  &__wrap {
    min-height: calc(100vh - 60px);
    background-color: rgba(255, 255, 255, 0.6);
    @include l-mobile {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
  &__header {
    height: 123px;
    @include l-mobile {
      height: 93px;
    }
    &-title {
      padding-top: 26px;
      font-size: 32px;
      letter-spacing: 0.2em;
      color: #000;
      text-align: center;
      @include l-mobile {
        padding-top: 22px;
      }
    }
    &-close {
      position: absolute;
      right: 15px;
      top: 15px;
      & a {
        display: block;
        width: 60px;
        height: 60px;
        @include l-mobile {
          width: 45px;
          height: 45px;
        }
      }
      &-line1 {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -30px;
        margin-top: -1px;
        width: 60px;
        height: 2px;
        background-color: #000;
        transform: rotate(45deg);
        @include l-mobile {
          margin-left: -22px;
          width: 44px;
        }
      }
      &-line2 {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -30px;
        margin-top: -1px;
        width: 60px;
        height: 2px;
        background-color: #000;
        transform: rotate(-45deg);
        @include l-mobile {
          margin-left: -22px;
          width: 44px;
        }
      }
    }
  }
  &__body {
    margin: 0 auto;
    padding-bottom: 90px;
    width: 60%;
    @include l-mobile {
      box-sizing: border-box;
      padding-right: 15px;
      padding-bottom: 57px;
      padding-left: 15px;
      width: 100%;
    }
    &-input {
      position: relative;
      margin-top: 60px;
      @include l-mobile {
        margin-top: 30px;
      }
      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #000;
      }
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #c00;
        transform: scaleX(0);
        transform-origin: left center;
        transition: transform 0.3s $easeOutQuart 0s;
      }
      &.err {
        &::after {
          transform: scaleX(1);
        }
      }
      & input {
        border: none !important;
        width: 100%;
        font-size: 22px;
        background: transparent;
        &::placeholder {
          color: #000;
        }
        &:focus,
        &:active {
          outline: 0;
        }
      }
    }
    &-textarea {
      position: relative;
      margin-top: 60px;
      @include l-mobile {
        margin-top: 30px;
      }
      &::before {
        content: "";
        box-sizing: border-box;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        border: 1px solid #000;
        pointer-events: none;
      }
      &::after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        border: 1px solid #c00;
        opacity: 0;
        transition: opacity 0.3s $easeOutQuart 0s;
        pointer-events: none;
      }
      &.err {
        &::after {
          opacity: 1;
        }
      }
      & textarea {
        box-sizing: border-box;
        border-radius: 0;
        border: none !important;
        max-width: 100%;
        width: 100%;
        height: 200px;
        border: 1px solid #000;
        font-size: 22px;
        background: transparent;
        @include l-mobile {
          font-size: 18px;
        }
        &:focus,
        &:active {
          outline: 0;
        }
      }
    }
    &-attention {
      padding-top: 26px;
      text-align: center;
      font-size: 22px;
      color: #c00;
      opacity: 0;
      &.on {
        opacity: 1;
      }
    }
    &-submit {
      display: flex;
      justify-content: center;
      padding-top: 30px;
      @include l-mobile {
        padding-top: 30px;
      }
      & button {
        border: 1px solid #000;
        width: 150px;
        height: 45px;
        font-size: 22px;
        letter-spacing: 0.1em;
        background: transparent;
        cursor: pointer;
        @include l-mobile {
          font-size: 18px;
        }
        &:focus,
        &:active {
          outline: 0;
        }
        & span {
          position: relative;
        }
      }
    }
  }
}

//
//
//
.contact__header-close a {
  transition: opacity 0.2s ease-out 0s;
  .contact__header-close-line1,
  .contact__header-close-line2 {
    transition: background-color 0.2s ease-out 0s;
  }
}
.contact__header-close a:hover {
  opacity: 0.6;
  .contact__header-close-line1,
  .contact__header-close-line2 {
    background-color: #0b2560;
  }
}

.contact__body-submit button {
  position: relative;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #000;
    transform: scaleY(0);
    transform-origin: center bottom;
    transition: transform 0.2s $easeOutQuart 0s;
  }
  & span {
    transition: color 0.2s ease-out 0s;
  }
}
.contact__body-submit button:hover {
  &::before {
    transform: scaleY(1);
  }
  & span {
    color: #fff;
  }
}
</style>
